import React from 'react'
import { Element } from 'react-scroll'
import SectionTitle2 from '../sectionTitle/SectionTitle2'
import { Link } from 'react-router-dom'

const HomeEdgeAIProductSuite = () => {
  const edgeAIProductSuite = [
    {
      icon: "spark",
      title: "MEA Spark",
      description: "Compact Edge AI Engine for Industrial Environments.",
      link: "m2m-edge-ai",
    },
    {
      icon: "globe",
      title: "MEA Gateway",
      description: "Centralized AI Hub for Distributed Edge Networks.",
      link: "m2m-edge-ai",
    },
    {
      icon: "server",
      title: "MEA Nexus",
      description: "Data Collection Node with Versatile I/O Modules.",
      link: "m2m-edge-ai",
    },
  ]
  return (
    <>
      <Element
        name="HomeEdgeAIProductSuite"
        className="datatalent-section-gap bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center"
                title = "Edge AI Product Suite"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center section-description">Modular, low-power Edge AI hardware platform and Agentic AI solutions for real-time, on-site intelligence across industries.</p>
            </div>
            {edgeAIProductSuite.map((product) => <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5" key={product.title}>
              <div className="home-applied-ai-solutions-card p-4 h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/${product.icon}.svg`} alt={product.icon} />
                </div>
                <h5 className="mt-3 mb-3">{product.title}</h5>
                <p>{product.description}</p>
                <Link className="d-flex flex-row align-items-center justify-content-start gap-2 home-links" to={`/products/${product.link}`}>Learn more<i className="icon-arrow-right-line-right"></i></Link>
              </div>
            </div>)}
          </div>
        </div>
      </Element>
    </>
  )
}

export default HomeEdgeAIProductSuite;